"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _semanticUiReact = require("semantic-ui-react");

var _GeoClosestLocation = _interopRequireDefault(require("../../darkmatter/GeoClosestLocation"));

var _Location = _interopRequireDefault(require("../../molecules/Location"));

var _SortByDistanceButton = _interopRequireDefault(require("./components/SortByDistanceButton"));

var _SearchLocations = _interopRequireDefault(require("./components/SearchLocations"));

require("./LocationsSorted.css");

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = (0, _getPrototypeOf2["default"])(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return (0, _possibleConstructorReturn2["default"])(this, result);
  };
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

var LocationsSorted = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(LocationsSorted, _React$Component);

  var _super = _createSuper(LocationsSorted);

  function LocationsSorted(props) {
    var _this;

    (0, _classCallCheck2["default"])(this, LocationsSorted);
    _this = _super.call(this, props);
    _this.state = {
      locations: props.locations,
      searchQuery: '',
      startOrderByDistance: false
    };
    _this.applyFilter = _this.applyFilter.bind((0, _assertThisInitialized2["default"])(_this));
    _this.onStartSortByDistance = _this.onStartSortByDistance.bind((0, _assertThisInitialized2["default"])(_this));
    _this.onSearchChange = _this.onSearchChange.bind((0, _assertThisInitialized2["default"])(_this));
    return _this;
  }

  (0, _createClass2["default"])(LocationsSorted, [{
    key: "applyFilter",
    value: function applyFilter() {
      var locations = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var searchQuery = this.state.searchQuery;
      var filteredLocations = locations;

      if (searchQuery && searchQuery.length) {
        var re = new RegExp(searchQuery, 'i');
        filteredLocations = locations.filter(function (loc) {
          var keys = Object.keys(loc);

          for (var i = 0; i < keys.length; i += 1) {
            var key = keys[i];

            if (key !== 'id' && (0, _typeof2["default"])(loc[key]) !== 'object' && re.test(loc[key])) {
              return true;
            }
          }

          return false;
        });
      }

      return filteredLocations;
    }
  }, {
    key: "onStartSortByDistance",
    value: function onStartSortByDistance() {
      this.setState({
        startOrderByDistance: true
      });
    }
  }, {
    key: "onSearchChange",
    value: function onSearchChange(e) {
      this.setState({
        searchQuery: e.target.value
      }, this.applyFilter);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          locations = _this$props.locations,
          searchHeader = _this$props.searchHeader,
          searchPlaceholder = _this$props.searchPlaceholder,
          verticalAlign = _this$props.verticalAlign,
          horizontalAlign = _this$props.horizontalAlign,
          className = _this$props.className,
          showIcon = _this$props.showIcon,
          distanceUnit = _this$props.distanceUnit,
          map = _this$props.map;
      var _this$state = this.state,
          searchQuery = _this$state.searchQuery,
          startOrderByDistance = _this$state.startOrderByDistance;
      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_GeoClosestLocation["default"], {
        start: startOrderByDistance,
        locations: locations,
        distanceUnit: distanceUnit
      }, function (_ref) {
        var loading = _ref.loading,
            geoClosestLocations = _ref.locations,
            geoClosestLocationStatus = _ref.state;

        var filteredLocations = _this2.applyFilter(geoClosestLocations);

        var noResults = filteredLocations.length === 0;
        return /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Grid, {
          id: "location-grid",
          stackable: true,
          className: className,
          verticalAlign: verticalAlign,
          textAlign: horizontalAlign
        }, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Grid.Row, null, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Grid.Column, {
          width: 16
        }, /*#__PURE__*/_react["default"].createElement(_SearchLocations["default"], {
          onSearchChange: _this2.onSearchChange,
          searchHeader: searchHeader,
          searchQuery: searchQuery,
          searchPlaceholder: searchPlaceholder,
          locationSortingStatus: geoClosestLocationStatus,
          onSort: _this2.onStartSortByDistance,
          distanceLoading: loading
        }))), /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Grid.Row, null, noResults && /*#__PURE__*/_react["default"].createElement("p", {
          style: {
            color: 'gray'
          }
        }, "No results found for the search \"", searchQuery, "\"."), filteredLocations.map(function (loc) {
          return /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Grid.Column, {
            id: loc.id,
            computer: 8,
            tablet: 8,
            mobile: 16,
            className: "location-filter-location-detail"
          }, /*#__PURE__*/_react["default"].createElement(_Location["default"], (0, _extends2["default"])({
            address: {
              street: loc.street,
              city: loc.city,
              state: loc.state,
              zip: loc.zipCode,
              country: loc.country
            },
            timezone: loc.timezone,
            hours: loc.hours,
            phone: loc.phoneNumber,
            as: "card",
            showAddress: true,
            showIcon: showIcon,
            showMap: filteredLocations.length === 1
          }, loc)));
        })));
      }));
    }
  }]);
  return LocationsSorted;
}(_react["default"].Component);

exports["default"] = LocationsSorted;
LocationsSorted.propTypes = {
  searchHeader: _propTypes["default"].string,
  searchPlaceholder: _propTypes["default"].string,
  locations: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    name: _propTypes["default"].string,
    phoneNumber: _propTypes["default"].string,
    email: _propTypes["default"].string,
    phone: _propTypes["default"].string,
    hours: _propTypes["default"].array,
    street: _propTypes["default"].string,
    city: _propTypes["default"].string,
    state: _propTypes["default"].string,
    zipCode: _propTypes["default"].string,
    country: _propTypes["default"].string,
    latitude: _propTypes["default"].string,
    longitude: _propTypes["default"].string,
    actions: _propTypes["default"].arrayOf(_propTypes["default"].shape({
      url: _propTypes["default"].string,
      icon: _propTypes["default"].string,
      label: _propTypes["default"].string
    }))
  })).isRequired,
  verticalAlign: _propTypes["default"].string,
  horizontalAlign: _propTypes["default"].string,
  showIcon: _propTypes["default"].bool
};
LocationsSorted.defaultProps = {
  locations: [],
  searchHeader: 'Search Our Locations',
  searchPlaceholder: '123 Main Street, Boston MA',
  verticalAlign: 'center',
  horizontalAlign: 'center',
  showIcon: true,
  map: false
};